/**
 * Parses a date string and returns a Date object.
 * @param {string} str - The date string to parse.
 * @returns {Date|null} The Date object or null if the input is invalid.
 */
export default function (str) {
  if (!str) {
    return null
  }
  const date = new Date(str)
  if (isNaN(date)) {
    return null
  }
  return date
}
